<template>
    <flex-container
        align-items="center"
        height="full"
        no-wrap
    >
        <collapse-box-decorator
            fill
            horizontal-position="center"
            vertical-position="bottom"
        >
            <template #default>
                <button type="button" class="lead-list-pipeline-filter">
                    <text-decorator bold>
                        Flow
                        <template v-if="activePipeline">
                            ({{ activePipeline?.name }})
                        </template>
                    </text-decorator>
                    <svg-icon
                        :icon="ArrowDownIcon"
                        :size="IconSize.sm"
                        is-custom-icon
                    />
                </button>
            </template>
            <template
                v-if="availablePipelines.length > 0"
                #title
            >
                Kies een flow om te filteren
            </template>
            <template
                v-if="availablePipelines.length > 0"
                #content
            >
                <collapse-option-container>
                    <collapse-option @click="emit('filter-pipeline-id', null)">
                        Alle
                    </collapse-option>
                    <collapse-option
                        v-for="pipeline in availablePipelines"
                        :key="pipeline.id"
                        @click="emit('filter-pipeline-id', pipeline.id)"
                    >
                        {{ pipeline.name }}
                    </collapse-option>
                </collapse-option-container>
            </template>
        </collapse-box-decorator>
    </flex-container>
</template>

<script setup lang="ts">
    import ArrowDownIcon from '@keyvue/one-awesome-icons/icons/regular/chevron-down.svg?component';
    import type { Pipeline, PipelineCategory, PipelineId } from '@keyvue/one-api-client';
    import type { ReactiveCollection } from '@/services/keyvue-api/composables/useClient';
    import { computed } from 'vue';
    import { IconSize } from '@keyvue/one-ui';

    const props = defineProps<{
        pipelineCollection: ReactiveCollection<Pipeline>,
        activePipelineCategory: PipelineCategory | null,
        activePipelineId: PipelineId | null,
    }>();

    const emit = defineEmits<{
        (e: 'filter-pipeline-id', value: PipelineId | null): void;
    }>();

    const activePipeline = computed(() => (props.pipelineCollection.data.value.find(
        (pipeline) => pipeline.id.equals(props.activePipelineId),
    )));

    const availablePipelines = computed(() => {
        return props.pipelineCollection.data.value
            .filter((pipeline) => {
                if (!props.activePipelineCategory) {
                    return true;
                }

                return props.activePipelineCategory.equals(pipeline.category);
            })
            .sort((a, b) => a.name.localeCompare(b.name));
    });
</script>

<style scoped lang="scss">
.lead-list-pipeline-filter {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    padding: size(sm);
    gap: size(sm);
    border: 1px solid color(gray-800);
    border-radius: size(xs);
    min-width: 100px;
    height: size(xl);
    background-color: transparent;
}
</style>
